import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { Component, Inject, Input, ViewChild } from '@angular/core';
import { EntidadResponsableComponent } from '../../entidad-responsable/entidad-responsable.component';
import { EntidadResponsableService } from '../../entidad-responsable/entidad-responsable.service';

@Component({
  selector: 'crear-entidad-responsable-dialog',
  templateUrl: './crear-entidad-responsable-dialog.component.html',
  styleUrls: ['./crear-entidad-responsable-dialog.component.scss']
})
export class CrearEntidadResponsableDialog {
  error: string = '';
  cargando: boolean = false;

  @ViewChild(EntidadResponsableComponent) // accedemos al formulario de carga
  private entidadResponsableForm: EntidadResponsableComponent;

  constructor(
    public dialogCrear: MatDialogRef<CrearEntidadResponsableDialog>,
    private entidadResponsableService: EntidadResponsableService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public snackBar: MatSnackBar
  ) { }

  onEntidadResponsableInput() { // si cambian los datos ingresados
    this.error = ''; // limpiamos los mensajes de error del formulario
  }

  onFormState(formState: any): void { // escucha los diferentes estados del formulario
    if (formState.estado && formState.estado != 1) { // ocurrio un error en el formulario
      this.error = formState.mensaje;
    }

    if (typeof formState.cargando != undefined) {
      this.cargando = formState.cargando;
    }
  }

  onCancelar(): void {
    this.dialogCrear.close();
  }

  onCrear(): void {
    this.error = '';

    try { // cacheo de errores antes de llamar al servidor
      this.cargando = true;
      this.entidadResponsableService.crearResponsableEntidad(
        this.data.IdEntidad,
        this.entidadResponsableForm.getEntidadResponsable()
      ).subscribe(
        respuesta => {
          if (respuesta.estado == 1) {
            this.snackBar.open(respuesta.mensaje, 'OK', { duration: 2750 });
            this.dialogCrear.close(respuesta);
          } else {
            this.error = respuesta.mensaje;
          }

          this.cargando = false;
        },
        error => {
          this.cargando = false;
          this.error = error;
        });
    } catch (error) {
      this.error = error;
      this.cargando = false;
    }
  }
}